export default "__VITE_ASSET__BOZt4DgA__"